/**
 * Utility functions for overbooking verification
 */

/**
 * Checks if a trip is eligible for overbooking.
 * A trip is eligible for overbooking if it has the 'oversold' passenger type and zero availability.
 *
 * @param {Object} trip - The trip object to check
 * @returns {boolean} - Whether the trip is eligible for overbooking
 */
export const isOverbookingEligible = (trip) => {
  return (
    trip?.passengerTypes?.filter(({ type }) => type === 'oversold').length > 0 &&
    trip?.availability === 0
  );
};

/**
 * Checks if there are already selected oversold seats in the passenger list.
 *
 * @param {Array} passengers - The list of passengers to check
 * @returns {boolean} - Whether there are any oversold seats already selected
 */
export const hasOversoldSeats = (seats) => {
  return seats?.some(
    (seat) =>
      seat.category === 'oversold' &&
      (seat.number === null || seat.number === '' || seat.number === undefined),
  );
};

/**
 * Extracts the availability of the "oversold" type from a list of items.
 *
 * @param {Array} items - The list of items to search in (e.g., passengerTypes, busCategories)
 * @returns {number|null} - The availability of the oversold type, or null if not found
 */
export const getOversoldAvailability = (items) => {
  const oversoldItem = items?.find(({ type }) => type === 'oversold');
  return oversoldItem?.availability ?? null;
};

/**
 * Export all overbooking utility functions
 */
export default {
  isOverbookingEligible,
  hasOversoldSeats,
  getOversoldAvailability,
};
